import type { IPropertyBag } from '@deity-io/di-data-basics';
import { Modal } from '@deity-io/portal-ui';
import { ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { Dispatch, FC, SetStateAction } from 'react';
import { useLocation } from 'react-router-dom';
import { getParams } from 'utils';

type ConfirmVariableModalProps = {
  variableKey: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onUpdate?: (key: string, value: IPropertyBag | undefined) => void;
};
const ConfirmDeleteVariableModal: FC<ConfirmVariableModalProps> = ({ variableKey, onUpdate, isOpen, setIsOpen }) => {
  const { pathname } = useLocation();
  const params: { [key: string]: string } = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);

  const removeVariable = async () => {
    if (onUpdate) {
      onUpdate(variableKey, undefined);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      label={`Variable ${variableKey}`}
      title="Are you sure that you want to remove this variable?"
      confirmText="Delete"
      onConfirm={() => removeVariable()}
    />
  );
};

export default ConfirmDeleteVariableModal;
